export const BaseEntityParameterId = 'BaseEntity';
export const RelatedEntityParameterId = 'RelatedEntity';
